var $jzHdg$reactarialiveannouncer = require("@react-aria/live-announcer");
var $jzHdg$reactariautils = require("@react-aria/utils");
var $jzHdg$reactariai18n = require("@react-aria/i18n");
var $jzHdg$react = require("react");
var $jzHdg$internationalizeddate = require("@internationalized/date");
var $jzHdg$reactariainteractions = require("@react-aria/interactions");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "useCalendar", () => $20e845123e697a89$export$3ee915f8151bd4f1);
$parcel$export(module.exports, "useRangeCalendar", () => $c49ada48cbc48220$export$87e0539f600c24e5);
$parcel$export(module.exports, "useCalendarGrid", () => $a07388a797d86b95$export$cb95147730a423f5);
$parcel$export(module.exports, "useCalendarCell", () => $4d833327a32c9193$export$136073280381448e);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */ /*
       * Copyright 2020 Adobe. All rights reserved.
       * This file is licensed to you under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License. You may obtain a copy
       * of the License at http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software distributed under
       * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
       * OF ANY KIND, either express or implied. See the License for the specific language
       * governing permissions and limitations under the License.
       */

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $bd6dc95a3c5ee5cd$exports = {};
var $1fedb39dedbf7c51$exports = {};
$1fedb39dedbf7c51$exports = {
  "dateRange": args => "".concat(args.startDate, " \u0625\u0644\u0649 ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " \u0627\u0644\u0645\u062D\u062F\u062F"),
  "finishRangeSelectionPrompt": "\u0627\u0646\u0642\u0631 \u0644\u0625\u0646\u0647\u0627\u0621 \u0639\u0645\u0644\u064A\u0629 \u062A\u062D\u062F\u064A\u062F \u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
  "maximumDate": "\u0622\u062E\u0631 \u062A\u0627\u0631\u064A\u062E \u0645\u062A\u0627\u062D",
  "minimumDate": "\u0623\u0648\u0644 \u062A\u0627\u0631\u064A\u062E \u0645\u062A\u0627\u062D",
  "next": "\u0627\u0644\u062A\u0627\u0644\u064A",
  "previous": "\u0627\u0644\u0633\u0627\u0628\u0642",
  "selectedDateDescription": args => "\u062A\u0627\u0631\u064A\u062E \u0645\u062D\u062F\u062F: ".concat(args.date),
  "selectedRangeDescription": args => "\u0627\u0644\u0645\u062F\u0649 \u0627\u0644\u0632\u0645\u0646\u064A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "\u0627\u0646\u0642\u0631 \u0644\u0628\u062F\u0621 \u0639\u0645\u0644\u064A\u0629 \u062A\u062D\u062F\u064A\u062F \u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
  "todayDate": args => "\u0627\u0644\u064A\u0648\u0645\u060C ".concat(args.date),
  "todayDateSelected": args => "\u0627\u0644\u064A\u0648\u0645\u060C ".concat(args.date, " \u0645\u062D\u062F\u062F")
};
var $524ada6153e36bf5$exports = {};
$524ada6153e36bf5$exports = {
  "dateRange": args => "".concat(args.startDate, " \u0434\u043E ").concat(args.endDate),
  "dateSelected": args => "\u0418\u0437\u0431\u0440\u0430\u043D\u043E \u0435 ".concat(args.date),
  "finishRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435, \u0437\u0430 \u0434\u0430 \u0434\u043E\u0432\u044A\u0440\u0448\u0438\u0442\u0435 \u0438\u0437\u0431\u043E\u0440\u0430 \u043D\u0430 \u0432\u0440\u0435\u043C\u0435\u0432\u0438 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B",
  "maximumDate": "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0434\u0430\u0442\u0430",
  "minimumDate": "\u041F\u044A\u0440\u0432\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0430 \u0434\u0430\u0442\u0430",
  "next": "\u041D\u0430\u043F\u0440\u0435\u0434",
  "previous": "\u041D\u0430\u0437\u0430\u0434",
  "selectedDateDescription": args => "\u0418\u0437\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date),
  "selectedRangeDescription": args => "\u0418\u0437\u0431\u0440\u0430\u043D \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435, \u0437\u0430 \u0434\u0430 \u043F\u0440\u0438\u0441\u0442\u044A\u043F\u0438\u0442\u0435 \u043A\u044A\u043C \u0438\u0437\u0431\u043E\u0440\u0430 \u043D\u0430 \u0432\u0440\u0435\u043C\u0435\u0432\u0438 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B",
  "todayDate": args => "\u0414\u043D\u0435\u0441, ".concat(args.date),
  "todayDateSelected": args => "\u0414\u043D\u0435\u0441, ".concat(args.date, " \u0441\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438")
};
var $181053d31fc585a6$exports = {};
$181053d31fc585a6$exports = {
  "dateRange": args => "".concat(args.startDate, " a\u017E ").concat(args.endDate),
  "dateSelected": args => "Vybr\xE1no ".concat(args.date),
  "finishRangeSelectionPrompt": "Kliknut\xEDm dokon\u010D\xEDte v\xFDb\u011Br rozsahu dat",
  "maximumDate": "Posledn\xED dostupn\xE9 datum",
  "minimumDate": "Prvn\xED dostupn\xE9 datum",
  "next": "Dal\u0161\xED",
  "previous": "P\u0159edchoz\xED",
  "selectedDateDescription": args => "Vybran\xE9 datum: ".concat(args.date),
  "selectedRangeDescription": args => "Vybran\xE9 obdob\xED: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Kliknut\xEDm zah\xE1j\xEDte v\xFDb\u011Br rozsahu dat",
  "todayDate": args => "Dnes, ".concat(args.date),
  "todayDateSelected": args => "Dnes, vybr\xE1no ".concat(args.date)
};
var $87f1f2ee75c25d27$exports = {};
$87f1f2ee75c25d27$exports = {
  "dateRange": args => "".concat(args.startDate, " til ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " valgt"),
  "finishRangeSelectionPrompt": "Klik for at fuldf\xF8re valg af datoomr\xE5de",
  "maximumDate": "Sidste ledige dato",
  "minimumDate": "F\xF8rste ledige dato",
  "next": "N\xE6ste",
  "previous": "Forrige",
  "selectedDateDescription": args => "Valgt dato: ".concat(args.date),
  "selectedRangeDescription": args => "Valgt interval: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Klik for at starte valg af datoomr\xE5de",
  "todayDate": args => "I dag, ".concat(args.date),
  "todayDateSelected": args => "I dag, ".concat(args.date, " valgt")
};
var $3018d278e45fefcf$exports = {};
$3018d278e45fefcf$exports = {
  "dateRange": args => "".concat(args.startDate, " bis ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " ausgew\xE4hlt"),
  "finishRangeSelectionPrompt": "Klicken, um die Auswahl des Datumsbereichs zu beenden",
  "maximumDate": "Letztes verf\xFCgbares Datum",
  "minimumDate": "Erstes verf\xFCgbares Datum",
  "next": "Weiter",
  "previous": "Zur\xFCck",
  "selectedDateDescription": args => "Ausgew\xE4hltes Datum: ".concat(args.date),
  "selectedRangeDescription": args => "Ausgew\xE4hlter Bereich: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Klicken, um die Auswahl des Datumsbereichs zu beginnen",
  "todayDate": args => "Heute, ".concat(args.date),
  "todayDateSelected": args => "Heute, ".concat(args.date, " ausgew\xE4hlt")
};
var $880b624ba6c377b6$exports = {};
$880b624ba6c377b6$exports = {
  "dateRange": args => "".concat(args.startDate, " \u03AD\u03C9\u03C2 ").concat(args.endDate),
  "dateSelected": args => "\u0395\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B5 ".concat(args.date),
  "finishRangeSelectionPrompt": "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03B5\u03CD\u03C1\u03BF\u03C5\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03B9\u03CE\u03BD",
  "maximumDate": "\u03A4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1",
  "minimumDate": "\u03A0\u03C1\u03CE\u03C4\u03B7 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1",
  "next": "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF",
  "previous": "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF",
  "selectedDateDescription": args => "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1: ".concat(args.date),
  "selectedRangeDescription": args => "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03B5\u03CD\u03C1\u03BF\u03C2: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03B5\u03CD\u03C1\u03BF\u03C5\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03B9\u03CE\u03BD",
  "todayDate": args => "\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1, ".concat(args.date),
  "todayDateSelected": args => "\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1, \u03B5\u03C0\u03B9\u03BB\u03AD\u03C7\u03C4\u03B7\u03BA\u03B5 ".concat(args.date)
};
var $6a7e3934431e9523$exports = {};
$6a7e3934431e9523$exports = {
  "previous": "Previous",
  "next": "Next",
  "selectedDateDescription": args => "Selected Date: ".concat(args.date),
  "selectedRangeDescription": args => "Selected Range: ".concat(args.dateRange),
  "todayDate": args => "Today, ".concat(args.date),
  "todayDateSelected": args => "Today, ".concat(args.date, " selected"),
  "dateSelected": args => "".concat(args.date, " selected"),
  "startRangeSelectionPrompt": "Click to start selecting date range",
  "finishRangeSelectionPrompt": "Click to finish selecting date range",
  "minimumDate": "First available date",
  "maximumDate": "Last available date",
  "dateRange": args => "".concat(args.startDate, " to ").concat(args.endDate)
};
var $4c458303ff44205c$exports = {};
$4c458303ff44205c$exports = {
  "dateRange": args => "".concat(args.startDate, " a ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " seleccionado"),
  "finishRangeSelectionPrompt": "Haga clic para terminar de seleccionar rango de fechas",
  "maximumDate": "\xDAltima fecha disponible",
  "minimumDate": "Primera fecha disponible",
  "next": "Siguiente",
  "previous": "Anterior",
  "selectedDateDescription": args => "Fecha seleccionada: ".concat(args.date),
  "selectedRangeDescription": args => "Intervalo seleccionado: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Haga clic para comenzar a seleccionar un rango de fechas",
  "todayDate": args => "Hoy, ".concat(args.date),
  "todayDateSelected": args => "Hoy, ".concat(args.date, " seleccionado")
};
var $4b6ec4ab19a96fff$exports = {};
$4b6ec4ab19a96fff$exports = {
  "dateRange": args => "".concat(args.startDate, " kuni ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " valitud"),
  "finishRangeSelectionPrompt": "Kl\xF5psake kuup\xE4evavahemiku valimise l\xF5petamiseks",
  "maximumDate": "Viimane saadaolev kuup\xE4ev",
  "minimumDate": "Esimene saadaolev kuup\xE4ev",
  "next": "J\xE4rgmine",
  "previous": "Eelmine",
  "selectedDateDescription": args => "Valitud kuup\xE4ev: ".concat(args.date),
  "selectedRangeDescription": args => "Valitud vahemik: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Kl\xF5psake kuup\xE4evavahemiku valimiseks",
  "todayDate": args => "T\xE4na, ".concat(args.date),
  "todayDateSelected": args => "T\xE4na, ".concat(args.date, " valitud")
};
var $a5184a366ed55e98$exports = {};
$a5184a366ed55e98$exports = {
  "dateRange": args => "".concat(args.startDate, " \u2013 ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " valittu"),
  "finishRangeSelectionPrompt": "Lopeta p\xE4iv\xE4m\xE4\xE4r\xE4alueen valinta napsauttamalla t\xE4t\xE4.",
  "maximumDate": "Viimeinen varattavissa oleva p\xE4iv\xE4m\xE4\xE4r\xE4",
  "minimumDate": "Ensimm\xE4inen varattavissa oleva p\xE4iv\xE4m\xE4\xE4r\xE4",
  "next": "Seuraava",
  "previous": "Edellinen",
  "selectedDateDescription": args => "Valittu p\xE4iv\xE4m\xE4\xE4r\xE4: ".concat(args.date),
  "selectedRangeDescription": args => "Valittu aikav\xE4li: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Aloita p\xE4iv\xE4m\xE4\xE4r\xE4alueen valinta napsauttamalla t\xE4t\xE4.",
  "todayDate": args => "T\xE4n\xE4\xE4n, ".concat(args.date),
  "todayDateSelected": args => "T\xE4n\xE4\xE4n, ".concat(args.date, " valittu")
};
var $094c11f0389b0f6c$exports = {};
$094c11f0389b0f6c$exports = {
  "dateRange": args => "".concat(args.startDate, " \xE0 ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " s\xE9lectionn\xE9"),
  "finishRangeSelectionPrompt": "Cliquer pour finir de s\xE9lectionner la plage de dates",
  "maximumDate": "Derni\xE8re date disponible",
  "minimumDate": "Premi\xE8re date disponible",
  "next": "Suivant",
  "previous": "Pr\xE9c\xE9dent",
  "selectedDateDescription": args => "Date s\xE9lectionn\xE9e\xA0: ".concat(args.date),
  "selectedRangeDescription": args => "Plage s\xE9lectionn\xE9e\xA0: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Cliquer pour commencer \xE0 s\xE9lectionner la plage de dates",
  "todayDate": args => "Aujourd'hui, ".concat(args.date),
  "todayDateSelected": args => "Aujourd\u2019hui, ".concat(args.date, " s\xE9lectionn\xE9")
};
var $5b28c6b8eb99673e$exports = {};
$5b28c6b8eb99673e$exports = {
  "dateRange": args => "".concat(args.startDate, " \u05E2\u05D3 ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " \u05E0\u05D1\u05D7\u05E8"),
  "finishRangeSelectionPrompt": "\u05D7\u05E5 \u05DB\u05D3\u05D9 \u05DC\u05E1\u05D9\u05D9\u05DD \u05D0\u05EA \u05D1\u05D7\u05D9\u05E8\u05EA \u05D8\u05D5\u05D5\u05D7 \u05D4\u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD",
  "maximumDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E4\u05E0\u05D5\u05D9 \u05D0\u05D7\u05E8\u05D5\u05DF",
  "minimumDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E4\u05E0\u05D5\u05D9 \u05E8\u05D0\u05E9\u05D5\u05DF",
  "next": "\u05D4\u05D1\u05D0",
  "previous": "\u05D4\u05E7\u05D5\u05D3\u05DD",
  "selectedDateDescription": args => "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E0\u05D1\u05D7\u05E8: ".concat(args.date),
  "selectedRangeDescription": args => "\u05D8\u05D5\u05D5\u05D7 \u05E0\u05D1\u05D7\u05E8: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "\u05DC\u05D7\u05E5 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC \u05D1\u05D1\u05D7\u05D9\u05E8\u05EA \u05D8\u05D5\u05D5\u05D7 \u05D4\u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD",
  "todayDate": args => "\u05D4\u05D9\u05D5\u05DD, ".concat(args.date),
  "todayDateSelected": args => "\u05D4\u05D9\u05D5\u05DD, ".concat(args.date, " \u05E0\u05D1\u05D7\u05E8")
};
var $519824243c1aad60$exports = {};
$519824243c1aad60$exports = {
  "dateRange": args => "".concat(args.startDate, " do ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " odabran"),
  "finishRangeSelectionPrompt": "Kliknite da dovr\u0161ite raspon odabranih datuma",
  "maximumDate": "Posljednji raspolo\u017Eivi datum",
  "minimumDate": "Prvi raspolo\u017Eivi datum",
  "next": "Sljede\u0107i",
  "previous": "Prethodni",
  "selectedDateDescription": args => "Odabrani datum: ".concat(args.date),
  "selectedRangeDescription": args => "Odabrani raspon: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Kliknite da zapo\u010Dnete raspon odabranih datuma",
  "todayDate": args => "Danas, ".concat(args.date),
  "todayDateSelected": args => "Danas, odabran ".concat(args.date)
};
var $2fde332abe847288$exports = {};
$2fde332abe847288$exports = {
  "dateRange": args => "".concat(args.startDate, "\u2013").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " kiv\xE1lasztva"),
  "finishRangeSelectionPrompt": "Kattintson a d\xE1tumtartom\xE1ny kijel\xF6l\xE9s\xE9nek befejez\xE9s\xE9hez",
  "maximumDate": "Utols\xF3 el\xE9rhet\u0151 d\xE1tum",
  "minimumDate": "Az els\u0151 el\xE9rhet\u0151 d\xE1tum",
  "next": "K\xF6vetkez\u0151",
  "previous": "El\u0151z\u0151",
  "selectedDateDescription": args => "Kijel\xF6lt d\xE1tum: ".concat(args.date),
  "selectedRangeDescription": args => "Kijel\xF6lt tartom\xE1ny: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Kattintson a d\xE1tumtartom\xE1ny kijel\xF6l\xE9s\xE9nek ind\xEDt\xE1s\xE1hoz",
  "todayDate": args => "Ma, ".concat(args.date),
  "todayDateSelected": args => "Ma, ".concat(args.date, " kijel\xF6lve")
};
var $b266f7fa452e8e83$exports = {};
$b266f7fa452e8e83$exports = {
  "dateRange": args => "Da ".concat(args.startDate, " a ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " selezionata"),
  "finishRangeSelectionPrompt": "Fai clic per completare la selezione dell\u2019intervallo di date",
  "maximumDate": "Ultima data disponibile",
  "minimumDate": "Prima data disponibile",
  "next": "Successivo",
  "previous": "Precedente",
  "selectedDateDescription": args => "Data selezionata: ".concat(args.date),
  "selectedRangeDescription": args => "Intervallo selezionato: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Fai clic per selezionare l\u2019intervallo di date",
  "todayDate": args => "Oggi, ".concat(args.date),
  "todayDateSelected": args => "Oggi, ".concat(args.date, " selezionata")
};
var $3528fd03237947e3$exports = {};
$3528fd03237947e3$exports = {
  "dateRange": args => "".concat(args.startDate, " \u304B\u3089 ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " \u3092\u9078\u629E"),
  "finishRangeSelectionPrompt": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u65E5\u4ED8\u7BC4\u56F2\u306E\u9078\u629E\u3092\u7D42\u4E86",
  "maximumDate": "\u6700\u7D42\u5229\u7528\u53EF\u80FD\u65E5",
  "minimumDate": "\u6700\u521D\u306E\u5229\u7528\u53EF\u80FD\u65E5",
  "next": "\u6B21\u3078",
  "previous": "\u524D\u3078",
  "selectedDateDescription": args => "\u9078\u629E\u3057\u305F\u65E5\u4ED8 : ".concat(args.date),
  "selectedRangeDescription": args => "\u9078\u629E\u7BC4\u56F2 : ".concat(args.dateRange),
  "startRangeSelectionPrompt": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u65E5\u4ED8\u7BC4\u56F2\u306E\u9078\u629E\u3092\u958B\u59CB",
  "todayDate": args => "\u672C\u65E5\u3001".concat(args.date),
  "todayDateSelected": args => "\u672C\u65E5\u3001".concat(args.date, " \u3092\u9078\u629E")
};
var $398f3b7902d2708f$exports = {};
$398f3b7902d2708f$exports = {
  "dateRange": args => "".concat(args.startDate, " ~ ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " \uC120\uD0DD\uB428"),
  "finishRangeSelectionPrompt": "\uB0A0\uC9DC \uBC94\uC704 \uC120\uD0DD\uC744 \uC644\uB8CC\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.",
  "maximumDate": "\uB9C8\uC9C0\uB9C9\uC73C\uB85C \uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uC77C\uC790",
  "minimumDate": "\uCC98\uC74C\uC73C\uB85C \uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uC77C\uC790",
  "next": "\uB2E4\uC74C",
  "previous": "\uC774\uC804",
  "selectedDateDescription": args => "\uC120\uD0DD \uC77C\uC790: ".concat(args.date),
  "selectedRangeDescription": args => "\uC120\uD0DD \uBC94\uC704: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "\uB0A0\uC9DC \uBC94\uC704 \uC120\uD0DD\uC744 \uC2DC\uC791\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC2ED\uC2DC\uC624.",
  "todayDate": args => "\uC624\uB298, ".concat(args.date),
  "todayDateSelected": args => "\uC624\uB298, ".concat(args.date, " \uC120\uD0DD\uB428")
};
var $ebaae1c76687311e$exports = {};
$ebaae1c76687311e$exports = {
  "dateRange": args => "Nuo ".concat(args.startDate, " iki ").concat(args.endDate),
  "dateSelected": args => "Pasirinkta ".concat(args.date),
  "finishRangeSelectionPrompt": "Spustel\u0117kite, kad baigtum\u0117te pasirinkti dat\u0173 interval\u0105",
  "maximumDate": "Paskutin\u0117 galima data",
  "minimumDate": "Pirmoji galima data",
  "next": "Paskesnis",
  "previous": "Ankstesnis",
  "selectedDateDescription": args => "Pasirinkta data: ".concat(args.date),
  "selectedRangeDescription": args => "Pasirinktas intervalas: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Spustel\u0117kite, kad prad\u0117tum\u0117te pasirinkti dat\u0173 interval\u0105",
  "todayDate": args => "\u0160iandien, ".concat(args.date),
  "todayDateSelected": args => "\u0160iandien, pasirinkta ".concat(args.date)
};
var $3ecb31d6694563f6$exports = {};
$3ecb31d6694563f6$exports = {
  "dateRange": args => "No ".concat(args.startDate, " l\u012Bdz ").concat(args.endDate),
  "dateSelected": args => "Atlas\u012Bts: ".concat(args.date),
  "finishRangeSelectionPrompt": "Noklik\u0161\u0137iniet, lai pabeigtu datumu diapazona atlasi",
  "maximumDate": "P\u0113d\u0113jais pieejamais datums",
  "minimumDate": "Pirmais pieejamais datums",
  "next": "T\u0101l\u0101k",
  "previous": "Atpaka\u013C",
  "selectedDateDescription": args => "Atlas\u012Btais datums: ".concat(args.date),
  "selectedRangeDescription": args => "Atlas\u012Btais diapazons: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Noklik\u0161\u0137iniet, lai s\u0101ktu datumu diapazona atlasi",
  "todayDate": args => "\u0160odien, ".concat(args.date),
  "todayDateSelected": args => "Atlas\u012Bta \u0161odiena, ".concat(args.date)
};
var $26dc2e2c103f178c$exports = {};
$26dc2e2c103f178c$exports = {
  "dateRange": args => "".concat(args.startDate, " til ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " valgt"),
  "finishRangeSelectionPrompt": "Klikk for \xE5 fullf\xF8re valg av datoomr\xE5de",
  "maximumDate": "Siste tilgjengelige dato",
  "minimumDate": "F\xF8rste tilgjengelige dato",
  "next": "Neste",
  "previous": "Forrige",
  "selectedDateDescription": args => "Valgt dato: ".concat(args.date),
  "selectedRangeDescription": args => "Valgt omr\xE5de: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Klikk for \xE5 starte valg av datoomr\xE5de",
  "todayDate": args => "I dag, ".concat(args.date),
  "todayDateSelected": args => "I dag, ".concat(args.date, " valgt")
};
var $6bfd45b83a7d37dd$exports = {};
$6bfd45b83a7d37dd$exports = {
  "dateRange": args => "".concat(args.startDate, " tot ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " geselecteerd"),
  "finishRangeSelectionPrompt": "Klik om de selectie van het datumbereik te voltooien",
  "maximumDate": "Laatste beschikbare datum",
  "minimumDate": "Eerste beschikbare datum",
  "next": "Volgende",
  "previous": "Vorige",
  "selectedDateDescription": args => "Geselecteerde datum: ".concat(args.date),
  "selectedRangeDescription": args => "Geselecteerd bereik: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Klik om het datumbereik te selecteren",
  "todayDate": args => "Vandaag, ".concat(args.date),
  "todayDateSelected": args => "Vandaag, ".concat(args.date, " geselecteerd")
};
var $6f70d036cac4bd46$exports = {};
$6f70d036cac4bd46$exports = {
  "dateRange": args => "".concat(args.startDate, " do ").concat(args.endDate),
  "dateSelected": args => "Wybrano ".concat(args.date),
  "finishRangeSelectionPrompt": "Kliknij, aby zako\u0144czy\u0107 wyb\xF3r zakresu dat",
  "maximumDate": "Ostatnia dost\u0119pna data",
  "minimumDate": "Pierwsza dost\u0119pna data",
  "next": "Dalej",
  "previous": "Wstecz",
  "selectedDateDescription": args => "Wybrana data: ".concat(args.date),
  "selectedRangeDescription": args => "Wybrany zakres: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Kliknij, aby rozpocz\u0105\u0107 wyb\xF3r zakresu dat",
  "todayDate": args => "Dzisiaj, ".concat(args.date),
  "todayDateSelected": args => "Dzisiaj wybrano ".concat(args.date)
};
var $a227ce57c671783d$exports = {};
$a227ce57c671783d$exports = {
  "dateRange": args => "".concat(args.startDate, " a ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " selecionado"),
  "finishRangeSelectionPrompt": "Clique para concluir a sele\xE7\xE3o do intervalo de datas",
  "maximumDate": "\xDAltima data dispon\xEDvel",
  "minimumDate": "Primeira data dispon\xEDvel",
  "next": "Pr\xF3ximo",
  "previous": "Anterior",
  "selectedDateDescription": args => "Data selecionada: ".concat(args.date),
  "selectedRangeDescription": args => "Intervalo selecionado: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Clique para iniciar a sele\xE7\xE3o do intervalo de datas",
  "todayDate": args => "Hoje, ".concat(args.date),
  "todayDateSelected": args => "Hoje, ".concat(args.date, " selecionado")
};
var $97acad4758696d87$exports = {};
$97acad4758696d87$exports = {
  "dateRange": args => "".concat(args.startDate, " a ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " selecionado"),
  "finishRangeSelectionPrompt": "Clique para terminar de selecionar o intervalo de datas",
  "maximumDate": "\xDAltima data dispon\xEDvel",
  "minimumDate": "Primeira data dispon\xEDvel",
  "next": "Pr\xF3ximo",
  "previous": "Anterior",
  "selectedDateDescription": args => "Data selecionada: ".concat(args.date),
  "selectedRangeDescription": args => "Intervalo selecionado: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Clique para come\xE7ar a selecionar o intervalo de datas",
  "todayDate": args => "Hoje, ".concat(args.date),
  "todayDateSelected": args => "Hoje, ".concat(args.date, " selecionado")
};
var $010069c7d7fbbea3$exports = {};
$010069c7d7fbbea3$exports = {
  "dateRange": args => "De la ".concat(args.startDate, " p\xE2n\u0103 la ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " selectat\u0103"),
  "finishRangeSelectionPrompt": "Ap\u0103sa\u0163i pentru a finaliza selec\u0163ia razei pentru dat\u0103",
  "maximumDate": "Ultima dat\u0103 disponibil\u0103",
  "minimumDate": "Prima dat\u0103 disponibil\u0103",
  "next": "Urm\u0103torul",
  "previous": "\xCEnainte",
  "selectedDateDescription": args => "Dat\u0103 selectat\u0103: ".concat(args.date),
  "selectedRangeDescription": args => "Interval selectat: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Ap\u0103sa\u0163i pentru a \xEEncepe selec\u0163ia razei pentru dat\u0103",
  "todayDate": args => "Ast\u0103zi, ".concat(args.date),
  "todayDateSelected": args => "Azi, ".concat(args.date, " selectat\u0103")
};
var $0ba9c30c48c8d602$exports = {};
$0ba9c30c48c8d602$exports = {
  "dateRange": args => "\u0421 ".concat(args.startDate, " \u043F\u043E ").concat(args.endDate),
  "dateSelected": args => "\u0412\u044B\u0431\u0440\u0430\u043D\u043E ".concat(args.date),
  "finishRangeSelectionPrompt": "\u0429\u0435\u043B\u043A\u043D\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D\u0430 \u0434\u0430\u0442",
  "maximumDate": "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430\u044F \u0434\u0430\u0442\u0430",
  "minimumDate": "\u041F\u0435\u0440\u0432\u0430\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430\u044F \u0434\u0430\u0442\u0430",
  "next": "\u0414\u0430\u043B\u0435\u0435",
  "previous": "\u041D\u0430\u0437\u0430\u0434",
  "selectedDateDescription": args => "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0434\u0430\u0442\u0430: ".concat(args.date),
  "selectedRangeDescription": args => "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "\u0429\u0435\u043B\u043A\u043D\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0432\u044B\u0431\u043E\u0440 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D\u0430 \u0434\u0430\u0442",
  "todayDate": args => "\u0421\u0435\u0433\u043E\u0434\u043D\u044F, ".concat(args.date),
  "todayDateSelected": args => "\u0421\u0435\u0433\u043E\u0434\u043D\u044F, \u0432\u044B\u0431\u0440\u0430\u043D\u043E ".concat(args.date)
};
var $6873e95bd7af7559$exports = {};
$6873e95bd7af7559$exports = {
  "dateRange": args => "Od ".concat(args.startDate, " do ").concat(args.endDate),
  "dateSelected": args => "Vybrat\xFD d\xE1tum ".concat(args.date),
  "finishRangeSelectionPrompt": "Kliknut\xEDm dokon\u010D\xEDte v\xFDber rozsahu d\xE1tumov",
  "maximumDate": "Posledn\xFD dostupn\xFD d\xE1tum",
  "minimumDate": "Prv\xFD dostupn\xFD d\xE1tum",
  "next": "Nasleduj\xFAce",
  "previous": "Predch\xE1dzaj\xFAce",
  "selectedDateDescription": args => "Vybrat\xFD d\xE1tum: ".concat(args.date),
  "selectedRangeDescription": args => "Vybrat\xFD rozsah: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Kliknut\xEDm spust\xEDte v\xFDber rozsahu d\xE1tumov",
  "todayDate": args => "Dnes ".concat(args.date),
  "todayDateSelected": args => "Vybrat\xFD dne\u0161n\xFD d\xE1tum ".concat(args.date)
};
var $ce3c7852583668e3$exports = {};
$ce3c7852583668e3$exports = {
  "dateRange": args => "".concat(args.startDate, " do ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " izbrano"),
  "finishRangeSelectionPrompt": "Kliknite za dokon\u010Danje izbire datumskega obsega",
  "maximumDate": "Zadnji razpolo\u017Eljivi datum",
  "minimumDate": "Prvi razpolo\u017Eljivi datum",
  "next": "Naprej",
  "previous": "Nazaj",
  "selectedDateDescription": args => "Izbrani datum: ".concat(args.date),
  "selectedRangeDescription": args => "Izbrano obmo\u010Dje: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Kliknite za za\u010Detek izbire datumskega obsega",
  "todayDate": args => "Danes, ".concat(args.date),
  "todayDateSelected": args => "Danes, ".concat(args.date, " izbrano")
};
var $36cbdcce92af5213$exports = {};
$36cbdcce92af5213$exports = {
  "dateRange": args => "".concat(args.startDate, " do ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " izabran"),
  "finishRangeSelectionPrompt": "Kliknite da dovr\u0161ite opseg izabranih datuma",
  "maximumDate": "Zadnji raspolo\u017Eivi datum",
  "minimumDate": "Prvi raspolo\u017Eivi datum",
  "next": "Slede\u0107i",
  "previous": "Prethodni",
  "selectedDateDescription": args => "Izabrani datum: ".concat(args.date),
  "selectedRangeDescription": args => "Izabrani period: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Kliknite da zapo\u010Dnete opseg izabranih datuma",
  "todayDate": args => "Danas, ".concat(args.date),
  "todayDateSelected": args => "Danas, izabran ".concat(args.date)
};
var $ce53fa032c8abdc9$exports = {};
$ce53fa032c8abdc9$exports = {
  "dateRange": args => "".concat(args.startDate, " till ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " har valts"),
  "finishRangeSelectionPrompt": "Klicka f\xF6r att avsluta val av datumintervall",
  "maximumDate": "Sista tillg\xE4ngliga datum",
  "minimumDate": "F\xF6rsta tillg\xE4ngliga datum",
  "next": "N\xE4sta",
  "previous": "F\xF6reg\xE5ende",
  "selectedDateDescription": args => "Valt datum: ".concat(args.date),
  "selectedRangeDescription": args => "Valt intervall: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Klicka f\xF6r att v\xE4lja datumintervall",
  "todayDate": args => "Idag, ".concat(args.date),
  "todayDateSelected": args => "Idag, ".concat(args.date, " har valts")
};
var $358703e281d51beb$exports = {};
$358703e281d51beb$exports = {
  "dateRange": args => "".concat(args.startDate, " - ").concat(args.endDate),
  "dateSelected": args => "".concat(args.date, " se\xE7ildi"),
  "finishRangeSelectionPrompt": "Tarih aral\u0131\u011F\u0131 se\xE7imini tamamlamak i\xE7in t\u0131klay\u0131n",
  "maximumDate": "Son m\xFCsait tarih",
  "minimumDate": "\u0130lk m\xFCsait tarih",
  "next": "Sonraki",
  "previous": "\xD6nceki",
  "selectedDateDescription": args => "Se\xE7ilen Tarih: ".concat(args.date),
  "selectedRangeDescription": args => "Se\xE7ilen Aral\u0131k: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "Tarih aral\u0131\u011F\u0131 se\xE7imini ba\u015Flatmak i\xE7in t\u0131klay\u0131n",
  "todayDate": args => "Bug\xFCn, ".concat(args.date),
  "todayDateSelected": args => "Bug\xFCn, ".concat(args.date, " se\xE7ildi")
};
var $16bef71241a84fd2$exports = {};
$16bef71241a84fd2$exports = {
  "dateRange": args => "".concat(args.startDate, " \u2014 ").concat(args.endDate),
  "dateSelected": args => "\u0412\u0438\u0431\u0440\u0430\u043D\u043E ".concat(args.date),
  "finishRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438 \u0432\u0438\u0431\u0456\u0440 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D\u0443 \u0434\u0430\u0442",
  "maximumDate": "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u0430\u0442\u0430",
  "minimumDate": "\u041F\u0435\u0440\u0448\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u0430\u0442\u0430",
  "next": "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
  "previous": "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
  "selectedDateDescription": args => "\u0412\u0438\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430: ".concat(args.date),
  "selectedRangeDescription": args => "\u0412\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D: ".concat(args.dateRange),
  "startRangeSelectionPrompt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D\u0443 \u0434\u0430\u0442",
  "todayDate": args => "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456, ".concat(args.date),
  "todayDateSelected": args => "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456, \u0432\u0438\u0431\u0440\u0430\u043D\u043E ".concat(args.date)
};
var $c80940728ad8dc0d$exports = {};
$c80940728ad8dc0d$exports = {
  "dateRange": args => "".concat(args.startDate, " \u81F3 ").concat(args.endDate),
  "dateSelected": args => "\u5DF2\u9009\u62E9 ".concat(args.date),
  "finishRangeSelectionPrompt": "\u5355\u51FB\u4EE5\u5B8C\u6210\u9009\u62E9\u65E5\u671F\u8303\u56F4",
  "maximumDate": "\u6700\u540E\u4E00\u4E2A\u53EF\u7528\u65E5\u671F",
  "minimumDate": "\u7B2C\u4E00\u4E2A\u53EF\u7528\u65E5\u671F",
  "next": "\u4E0B\u4E00\u9875",
  "previous": "\u4E0A\u4E00\u9875",
  "selectedDateDescription": args => "\u9009\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date),
  "selectedRangeDescription": args => "\u9009\u5B9A\u7684\u8303\u56F4\uFF1A".concat(args.dateRange),
  "startRangeSelectionPrompt": "\u5355\u51FB\u4EE5\u5F00\u59CB\u9009\u62E9\u65E5\u671F\u8303\u56F4",
  "todayDate": args => "\u4ECA\u5929\uFF0C\u5373 ".concat(args.date),
  "todayDateSelected": args => "\u5DF2\u9009\u62E9\u4ECA\u5929\uFF0C\u5373 ".concat(args.date)
};
var $ec192a5a83cfafeb$exports = {};
$ec192a5a83cfafeb$exports = {
  "dateRange": args => "".concat(args.startDate, " \u81F3 ").concat(args.endDate),
  "dateSelected": args => "\u5DF2\u9078\u53D6 ".concat(args.date),
  "finishRangeSelectionPrompt": "\u6309\u4E00\u4E0B\u4EE5\u5B8C\u6210\u9078\u53D6\u65E5\u671F\u7BC4\u570D",
  "maximumDate": "\u6700\u5F8C\u4E00\u500B\u53EF\u7528\u65E5\u671F",
  "minimumDate": "\u7B2C\u4E00\u500B\u53EF\u7528\u65E5\u671F",
  "next": "\u4E0B\u4E00\u9801",
  "previous": "\u4E0A\u4E00\u9801",
  "selectedDateDescription": args => "\u9078\u5B9A\u7684\u65E5\u671F\uFF1A".concat(args.date),
  "selectedRangeDescription": args => "\u9078\u5B9A\u7684\u7BC4\u570D\uFF1A".concat(args.dateRange),
  "startRangeSelectionPrompt": "\u6309\u4E00\u4E0B\u4EE5\u958B\u59CB\u9078\u53D6\u65E5\u671F\u7BC4\u570D",
  "todayDate": args => "\u4ECA\u5929\uFF0C".concat(args.date),
  "todayDateSelected": args => "\u5DF2\u9078\u53D6\u4ECA\u5929\uFF0C".concat(args.date)
};
$bd6dc95a3c5ee5cd$exports = {
  "ar-AE": $1fedb39dedbf7c51$exports,
  "bg-BG": $524ada6153e36bf5$exports,
  "cs-CZ": $181053d31fc585a6$exports,
  "da-DK": $87f1f2ee75c25d27$exports,
  "de-DE": $3018d278e45fefcf$exports,
  "el-GR": $880b624ba6c377b6$exports,
  "en-US": $6a7e3934431e9523$exports,
  "es-ES": $4c458303ff44205c$exports,
  "et-EE": $4b6ec4ab19a96fff$exports,
  "fi-FI": $a5184a366ed55e98$exports,
  "fr-FR": $094c11f0389b0f6c$exports,
  "he-IL": $5b28c6b8eb99673e$exports,
  "hr-HR": $519824243c1aad60$exports,
  "hu-HU": $2fde332abe847288$exports,
  "it-IT": $b266f7fa452e8e83$exports,
  "ja-JP": $3528fd03237947e3$exports,
  "ko-KR": $398f3b7902d2708f$exports,
  "lt-LT": $ebaae1c76687311e$exports,
  "lv-LV": $3ecb31d6694563f6$exports,
  "nb-NO": $26dc2e2c103f178c$exports,
  "nl-NL": $6bfd45b83a7d37dd$exports,
  "pl-PL": $6f70d036cac4bd46$exports,
  "pt-BR": $a227ce57c671783d$exports,
  "pt-PT": $97acad4758696d87$exports,
  "ro-RO": $010069c7d7fbbea3$exports,
  "ru-RU": $0ba9c30c48c8d602$exports,
  "sk-SK": $6873e95bd7af7559$exports,
  "sl-SI": $ce3c7852583668e3$exports,
  "sr-SP": $36cbdcce92af5213$exports,
  "sv-SE": $ce53fa032c8abdc9$exports,
  "tr-TR": $358703e281d51beb$exports,
  "uk-UA": $16bef71241a84fd2$exports,
  "zh-CN": $c80940728ad8dc0d$exports,
  "zh-TW": $ec192a5a83cfafeb$exports
};
const $df1d8e967e73ec8e$export$653eddfc964b0f8a = new WeakMap();
function $df1d8e967e73ec8e$export$134cbb7fb09a9522(date) {
  return (date === null || date === void 0 ? void 0 : date.calendar.identifier) === "gregory" && date.era === "BC" ? "short" : undefined;
}
function $df1d8e967e73ec8e$export$b6df97c887c38e1a(state) {
  let stringFormatter = (0, $jzHdg$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($bd6dc95a3c5ee5cd$exports)));
  let start, end;
  if ("highlightedRange" in state) ({
    start: start,
    end: end
  } = state.highlightedRange || {});else start = end = state.value;
  let dateFormatter = (0, $jzHdg$reactariai18n.useDateFormatter)({
    weekday: "long",
    month: "long",
    year: "numeric",
    day: "numeric",
    era: $df1d8e967e73ec8e$export$134cbb7fb09a9522(start) || $df1d8e967e73ec8e$export$134cbb7fb09a9522(end),
    timeZone: state.timeZone
  });
  let anchorDate = "anchorDate" in state ? state.anchorDate : null;
  return (0, $jzHdg$react.useMemo)(() => {
    // No message if currently selecting a range, or there is nothing highlighted.
    if (!anchorDate && start && end) {
      // Use a single date message if the start and end dates are the same day,
      // otherwise include both dates.
      if ((0, $jzHdg$internationalizeddate.isSameDay)(start, end)) {
        let date = dateFormatter.format(start.toDate(state.timeZone));
        return stringFormatter.format("selectedDateDescription", {
          date: date
        });
      } else {
        let dateRange = $df1d8e967e73ec8e$var$formatRange(dateFormatter, stringFormatter, start, end, state.timeZone);
        return stringFormatter.format("selectedRangeDescription", {
          dateRange: dateRange
        });
      }
    }
    return "";
  }, [start, end, anchorDate, state.timeZone, stringFormatter, dateFormatter]);
}
function $df1d8e967e73ec8e$export$31afe65d91ef6e8(startDate, endDate, timeZone, isAria) {
  let stringFormatter = (0, $jzHdg$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($bd6dc95a3c5ee5cd$exports)));
  let era = $df1d8e967e73ec8e$export$134cbb7fb09a9522(startDate) || $df1d8e967e73ec8e$export$134cbb7fb09a9522(endDate);
  let monthFormatter = (0, $jzHdg$reactariai18n.useDateFormatter)({
    month: "long",
    year: "numeric",
    era: era,
    calendar: startDate.calendar.identifier,
    timeZone: timeZone
  });
  let dateFormatter = (0, $jzHdg$reactariai18n.useDateFormatter)({
    month: "long",
    year: "numeric",
    day: "numeric",
    era: era,
    calendar: startDate.calendar.identifier,
    timeZone: timeZone
  });
  return (0, $jzHdg$react.useMemo)(() => {
    // Special case for month granularity. Format as a single month if only a
    // single month is visible, otherwise format as a range of months.
    if ((0, $jzHdg$internationalizeddate.isSameDay)(startDate, (0, $jzHdg$internationalizeddate.startOfMonth)(startDate))) {
      if ((0, $jzHdg$internationalizeddate.isSameDay)(endDate, (0, $jzHdg$internationalizeddate.endOfMonth)(startDate))) return monthFormatter.format(startDate.toDate(timeZone));else if ((0, $jzHdg$internationalizeddate.isSameDay)(endDate, (0, $jzHdg$internationalizeddate.endOfMonth)(endDate))) return isAria ? $df1d8e967e73ec8e$var$formatRange(monthFormatter, stringFormatter, startDate, endDate, timeZone) : monthFormatter.formatRange(startDate.toDate(timeZone), endDate.toDate(timeZone));
    }
    return isAria ? $df1d8e967e73ec8e$var$formatRange(dateFormatter, stringFormatter, startDate, endDate, timeZone) : dateFormatter.formatRange(startDate.toDate(timeZone), endDate.toDate(timeZone));
  }, [startDate, endDate, monthFormatter, dateFormatter, stringFormatter, timeZone, isAria]);
}
function $df1d8e967e73ec8e$var$formatRange(dateFormatter, stringFormatter, start, end, timeZone) {
  let parts = dateFormatter.formatRangeToParts(start.toDate(timeZone), end.toDate(timeZone));
  // Find the separator between the start and end date. This is determined
  // by finding the last shared literal before the end range.
  let separatorIndex = -1;
  for (let i = 0; i < parts.length; i++) {
    let part = parts[i];
    if (part.source === "shared" && part.type === "literal") separatorIndex = i;else if (part.source === "endRange") break;
  }
  // Now we can combine the parts into start and end strings.
  let startValue = "";
  let endValue = "";
  for (let i = 0; i < parts.length; i++) {
    if (i < separatorIndex) startValue += parts[i].value;else if (i > separatorIndex) endValue += parts[i].value;
  }
  return stringFormatter.format("dateRange", {
    startDate: startValue,
    endDate: endValue
  });
}
function $02ef492a56b91cb2$export$d652b3ea2d672d5b(props, state) {
  let stringFormatter = (0, $jzHdg$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($bd6dc95a3c5ee5cd$exports)));
  let domProps = (0, $jzHdg$reactariautils.filterDOMProps)(props);
  let title = (0, $df1d8e967e73ec8e$export$31afe65d91ef6e8)(state.visibleRange.start, state.visibleRange.end, state.timeZone, false);
  let visibleRangeDescription = (0, $df1d8e967e73ec8e$export$31afe65d91ef6e8)(state.visibleRange.start, state.visibleRange.end, state.timeZone, true);
  // Announce when the visible date range changes
  (0, $jzHdg$reactariautils.useUpdateEffect)(() => {
    // only when pressing the Previous or Next button
    if (!state.isFocused) (0, $jzHdg$reactarialiveannouncer.announce)(visibleRangeDescription);
  }, [visibleRangeDescription]);
  // Announce when the selected value changes
  let selectedDateDescription = (0, $df1d8e967e73ec8e$export$b6df97c887c38e1a)(state);
  (0, $jzHdg$reactariautils.useUpdateEffect)(() => {
    if (selectedDateDescription) (0, $jzHdg$reactarialiveannouncer.announce)(selectedDateDescription, "polite", 4000);
    // handle an update to the caption that describes the currently selected range, to announce the new value
  }, [selectedDateDescription]);
  let errorMessageId = (0, $jzHdg$reactariautils.useSlotId)([Boolean(props.errorMessage), props.isInvalid, props.validationState]);
  // Pass the label to the child grid elements.
  (0, $df1d8e967e73ec8e$export$653eddfc964b0f8a).set(state, {
    ariaLabel: props["aria-label"],
    ariaLabelledBy: props["aria-labelledby"],
    errorMessageId: errorMessageId,
    selectedDateDescription: selectedDateDescription
  });
  // If the next or previous buttons become disabled while they are focused, move focus to the calendar body.
  let [nextFocused, setNextFocused] = (0, $jzHdg$react.useState)(false);
  let nextDisabled = props.isDisabled || state.isNextVisibleRangeInvalid();
  if (nextDisabled && nextFocused) {
    setNextFocused(false);
    state.setFocused(true);
  }
  let [previousFocused, setPreviousFocused] = (0, $jzHdg$react.useState)(false);
  let previousDisabled = props.isDisabled || state.isPreviousVisibleRangeInvalid();
  if (previousDisabled && previousFocused) {
    setPreviousFocused(false);
    state.setFocused(true);
  }
  let labelProps = (0, $jzHdg$reactariautils.useLabels)({
    id: props["id"],
    "aria-label": [props["aria-label"], visibleRangeDescription].filter(Boolean).join(", "),
    "aria-labelledby": props["aria-labelledby"]
  });
  return {
    calendarProps: (0, $jzHdg$reactariautils.mergeProps)(domProps, labelProps, {
      role: "application",
      "aria-describedby": props["aria-describedby"] || undefined
    }),
    nextButtonProps: {
      onPress: () => state.focusNextPage(),
      "aria-label": stringFormatter.format("next"),
      isDisabled: nextDisabled,
      onFocusChange: setNextFocused
    },
    prevButtonProps: {
      onPress: () => state.focusPreviousPage(),
      "aria-label": stringFormatter.format("previous"),
      isDisabled: previousDisabled,
      onFocusChange: setPreviousFocused
    },
    errorMessageProps: {
      id: errorMessageId
    },
    title: title
  };
}
function $20e845123e697a89$export$3ee915f8151bd4f1(props, state) {
  return (0, $02ef492a56b91cb2$export$d652b3ea2d672d5b)(props, state);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $c49ada48cbc48220$export$87e0539f600c24e5(props, state, ref) {
  let res = (0, $02ef492a56b91cb2$export$d652b3ea2d672d5b)(props, state);
  // We need to ignore virtual pointer events from VoiceOver due to these bugs.
  // https://bugs.webkit.org/show_bug.cgi?id=222627
  // https://bugs.webkit.org/show_bug.cgi?id=223202
  // usePress also does this and waits for the following click event before firing.
  // We need to match that here otherwise this will fire before the press event in
  // useCalendarCell, causing range selection to not work properly.
  let isVirtualClick = (0, $jzHdg$react.useRef)(false);
  let windowRef = (0, $jzHdg$react.useRef)(typeof window !== "undefined" ? window : null);
  (0, $jzHdg$reactariautils.useEvent)(windowRef, "pointerdown", e => {
    isVirtualClick.current = e.width === 0 && e.height === 0;
  });
  // Stop range selection when pressing or releasing a pointer outside the calendar body,
  // except when pressing the next or previous buttons to switch months.
  let endDragging = e => {
    if (isVirtualClick.current) {
      isVirtualClick.current = false;
      return;
    }
    state.setDragging(false);
    if (!state.anchorDate) return;
    let target = e.target;
    let body = document.getElementById(res.calendarProps.id);
    if (body && body.contains(document.activeElement) && (!body.contains(target) || !target.closest('button, [role="button"]'))) state.selectFocusedDate();
  };
  (0, $jzHdg$reactariautils.useEvent)(windowRef, "pointerup", endDragging);
  (0, $jzHdg$reactariautils.useEvent)(windowRef, "pointercancel", endDragging);
  // Also stop range selection on blur, e.g. tabbing away from the calendar.
  res.calendarProps.onBlur = e => {
    if ((!e.relatedTarget || !ref.current.contains(e.relatedTarget)) && state.anchorDate) state.selectFocusedDate();
  };
  // Prevent touch scrolling while dragging
  (0, $jzHdg$reactariautils.useEvent)(ref, "touchmove", e => {
    if (state.isDragging) e.preventDefault();
  }, {
    passive: false,
    capture: true
  });
  return res;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $a07388a797d86b95$export$cb95147730a423f5(props, state) {
  let {
    startDate = state.visibleRange.start,
    endDate = state.visibleRange.end
  } = props;
  let {
    direction: direction
  } = (0, $jzHdg$reactariai18n.useLocale)();
  let onKeyDown = e => {
    switch (e.key) {
      case "Enter":
      case " ":
        e.preventDefault();
        state.selectFocusedDate();
        break;
      case "PageUp":
        e.preventDefault();
        e.stopPropagation();
        state.focusPreviousSection(e.shiftKey);
        break;
      case "PageDown":
        e.preventDefault();
        e.stopPropagation();
        state.focusNextSection(e.shiftKey);
        break;
      case "End":
        e.preventDefault();
        e.stopPropagation();
        state.focusSectionEnd();
        break;
      case "Home":
        e.preventDefault();
        e.stopPropagation();
        state.focusSectionStart();
        break;
      case "ArrowLeft":
        e.preventDefault();
        e.stopPropagation();
        if (direction === "rtl") state.focusNextDay();else state.focusPreviousDay();
        break;
      case "ArrowUp":
        e.preventDefault();
        e.stopPropagation();
        state.focusPreviousRow();
        break;
      case "ArrowRight":
        e.preventDefault();
        e.stopPropagation();
        if (direction === "rtl") state.focusPreviousDay();else state.focusNextDay();
        break;
      case "ArrowDown":
        e.preventDefault();
        e.stopPropagation();
        state.focusNextRow();
        break;
      case "Escape":
        // Cancel the selection.
        if ("setAnchorDate" in state) {
          e.preventDefault();
          state.setAnchorDate(null);
        }
        break;
    }
  };
  let visibleRangeDescription = (0, $df1d8e967e73ec8e$export$31afe65d91ef6e8)(startDate, endDate, state.timeZone, true);
  let {
    ariaLabel: ariaLabel,
    ariaLabelledBy: ariaLabelledBy
  } = (0, $df1d8e967e73ec8e$export$653eddfc964b0f8a).get(state);
  let labelProps = (0, $jzHdg$reactariautils.useLabels)({
    "aria-label": [ariaLabel, visibleRangeDescription].filter(Boolean).join(", "),
    "aria-labelledby": ariaLabelledBy
  });
  let dayFormatter = (0, $jzHdg$reactariai18n.useDateFormatter)({
    weekday: props.weekdayStyle || "narrow",
    timeZone: state.timeZone
  });
  let {
    locale: locale
  } = (0, $jzHdg$reactariai18n.useLocale)();
  let weekDays = (0, $jzHdg$react.useMemo)(() => {
    let weekStart = (0, $jzHdg$internationalizeddate.startOfWeek)((0, $jzHdg$internationalizeddate.today)(state.timeZone), locale);
    return [...new Array(7).keys()].map(index => {
      let date = weekStart.add({
        days: index
      });
      let dateDay = date.toDate(state.timeZone);
      return dayFormatter.format(dateDay);
    });
  }, [locale, state.timeZone, dayFormatter]);
  return {
    gridProps: (0, $jzHdg$reactariautils.mergeProps)(labelProps, {
      role: "grid",
      "aria-readonly": state.isReadOnly || null,
      "aria-disabled": state.isDisabled || null,
      "aria-multiselectable": "highlightedRange" in state || undefined,
      onKeyDown: onKeyDown,
      onFocus: () => state.setFocused(true),
      onBlur: () => state.setFocused(false)
    }),
    headerProps: {
      // Column headers are hidden to screen readers to make navigating with a touch screen reader easier.
      // The day names are already included in the label of each cell, so there's no need to announce them twice.
      "aria-hidden": true
    },
    weekDays: weekDays
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $4d833327a32c9193$export$136073280381448e(props, state, ref) {
  let {
    date: date,
    isDisabled: isDisabled
  } = props;
  let {
    errorMessageId: errorMessageId,
    selectedDateDescription: selectedDateDescription
  } = (0, $df1d8e967e73ec8e$export$653eddfc964b0f8a).get(state);
  let stringFormatter = (0, $jzHdg$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($bd6dc95a3c5ee5cd$exports)));
  let dateFormatter = (0, $jzHdg$reactariai18n.useDateFormatter)({
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    era: (0, $df1d8e967e73ec8e$export$134cbb7fb09a9522)(date),
    timeZone: state.timeZone
  });
  let isSelected = state.isSelected(date);
  let isFocused = state.isCellFocused(date);
  isDisabled = isDisabled || state.isCellDisabled(date);
  let isUnavailable = state.isCellUnavailable(date);
  let isSelectable = !isDisabled && !isUnavailable;
  let isInvalid = state.isValueInvalid && ("highlightedRange" in state ? !state.anchorDate && state.highlightedRange && date.compare(state.highlightedRange.start) >= 0 && date.compare(state.highlightedRange.end) <= 0 : state.value && (0, $jzHdg$internationalizeddate.isSameDay)(state.value, date));
  if (isInvalid) isSelected = true;
  // For performance, reuse the same date object as before if the new date prop is the same.
  // This allows subsequent useMemo results to be reused.
  date = (0, $jzHdg$reactariautils.useDeepMemo)(date, (0, $jzHdg$internationalizeddate.isEqualDay));
  let nativeDate = (0, $jzHdg$react.useMemo)(() => date.toDate(state.timeZone), [date, state.timeZone]);
  // aria-label should be localize Day of week, Month, Day and Year without Time.
  let isDateToday = (0, $jzHdg$internationalizeddate.isToday)(date, state.timeZone);
  let label = (0, $jzHdg$react.useMemo)(() => {
    let label = "";
    // If this is a range calendar, add a description of the full selected range
    // to the first and last selected date.
    if ("highlightedRange" in state && state.value && !state.anchorDate && ((0, $jzHdg$internationalizeddate.isSameDay)(date, state.value.start) || (0, $jzHdg$internationalizeddate.isSameDay)(date, state.value.end))) label = selectedDateDescription + ", ";
    label += dateFormatter.format(nativeDate);
    if (isDateToday)
      // If date is today, set appropriate string depending on selected state:
      label = stringFormatter.format(isSelected ? "todayDateSelected" : "todayDate", {
        date: label
      });else if (isSelected)
      // If date is selected but not today:
      label = stringFormatter.format("dateSelected", {
        date: label
      });
    if (state.minValue && (0, $jzHdg$internationalizeddate.isSameDay)(date, state.minValue)) label += ", " + stringFormatter.format("minimumDate");else if (state.maxValue && (0, $jzHdg$internationalizeddate.isSameDay)(date, state.maxValue)) label += ", " + stringFormatter.format("maximumDate");
    return label;
  }, [dateFormatter, nativeDate, stringFormatter, isSelected, isDateToday, date, state, selectedDateDescription]);
  // When a cell is focused and this is a range calendar, add a prompt to help
  // screenreader users know that they are in a range selection mode.
  let rangeSelectionPrompt = "";
  if ("anchorDate" in state && isFocused && !state.isReadOnly && isSelectable) {
    // If selection has started add "click to finish selecting range"
    if (state.anchorDate) rangeSelectionPrompt = stringFormatter.format("finishRangeSelectionPrompt");else rangeSelectionPrompt = stringFormatter.format("startRangeSelectionPrompt");
  }
  let descriptionProps = (0, $jzHdg$reactariautils.useDescription)(rangeSelectionPrompt);
  let isAnchorPressed = (0, $jzHdg$react.useRef)(false);
  let isRangeBoundaryPressed = (0, $jzHdg$react.useRef)(false);
  let touchDragTimerRef = (0, $jzHdg$react.useRef)(null);
  let {
    pressProps: pressProps,
    isPressed: isPressed
  } = (0, $jzHdg$reactariainteractions.usePress)({
    // When dragging to select a range, we don't want dragging over the original anchor
    // again to trigger onPressStart. Cancel presses immediately when the pointer exits.
    shouldCancelOnPointerExit: "anchorDate" in state && !!state.anchorDate,
    preventFocusOnPress: true,
    isDisabled: !isSelectable || state.isReadOnly,
    onPressStart(e) {
      if (state.isReadOnly) {
        state.setFocusedDate(date);
        return;
      }
      if ("highlightedRange" in state && !state.anchorDate && (e.pointerType === "mouse" || e.pointerType === "touch")) {
        // Allow dragging the start or end date of a range to modify it
        // rather than starting a new selection.
        // Don't allow dragging when invalid, or weird jumping behavior may occur as date ranges
        // are constrained to available dates. The user will need to select a new range in this case.
        if (state.highlightedRange && !isInvalid) {
          if ((0, $jzHdg$internationalizeddate.isSameDay)(date, state.highlightedRange.start)) {
            state.setAnchorDate(state.highlightedRange.end);
            state.setFocusedDate(date);
            state.setDragging(true);
            isRangeBoundaryPressed.current = true;
            return;
          } else if ((0, $jzHdg$internationalizeddate.isSameDay)(date, state.highlightedRange.end)) {
            state.setAnchorDate(state.highlightedRange.start);
            state.setFocusedDate(date);
            state.setDragging(true);
            isRangeBoundaryPressed.current = true;
            return;
          }
        }
        let startDragging = () => {
          state.setDragging(true);
          touchDragTimerRef.current = null;
          state.selectDate(date);
          state.setFocusedDate(date);
          isAnchorPressed.current = true;
        };
        // Start selection on mouse/touch down so users can drag to select a range.
        // On touch, delay dragging to determine if the user really meant to scroll.
        if (e.pointerType === "touch") touchDragTimerRef.current = setTimeout(startDragging, 200);else startDragging();
      }
    },
    onPressEnd() {
      isRangeBoundaryPressed.current = false;
      isAnchorPressed.current = false;
      clearTimeout(touchDragTimerRef.current);
      touchDragTimerRef.current = null;
    },
    onPress() {
      // For non-range selection, always select on press up.
      if (!("anchorDate" in state) && !state.isReadOnly) {
        state.selectDate(date);
        state.setFocusedDate(date);
      }
    },
    onPressUp(e) {
      if (state.isReadOnly) return;
      // If the user tapped quickly, the date won't be selected yet and the
      // timer will still be in progress. In this case, select the date on touch up.
      // Timer is cleared in onPressEnd.
      if ("anchorDate" in state && touchDragTimerRef.current) {
        state.selectDate(date);
        state.setFocusedDate(date);
      }
      if ("anchorDate" in state) {
        if (isRangeBoundaryPressed.current)
          // When clicking on the start or end date of an already selected range,
          // start a new selection on press up to also allow dragging the date to
          // change the existing range.
          state.setAnchorDate(date);else if (state.anchorDate && !isAnchorPressed.current) {
          // When releasing a drag or pressing the end date of a range, select it.
          state.selectDate(date);
          state.setFocusedDate(date);
        } else if (e.pointerType === "keyboard" && !state.anchorDate) {
          // For range selection, auto-advance the focused date by one if using keyboard.
          // This gives an indication that you're selecting a range rather than a single date.
          // For mouse, this is unnecessary because users will see the indication on hover. For screen readers,
          // there will be an announcement to "click to finish selecting range" (above).
          state.selectDate(date);
          let nextDay = date.add({
            days: 1
          });
          if (state.isInvalid(nextDay)) nextDay = date.subtract({
            days: 1
          });
          if (!state.isInvalid(nextDay)) state.setFocusedDate(nextDay);
        } else if (e.pointerType === "virtual") {
          // For screen readers, just select the date on click.
          state.selectDate(date);
          state.setFocusedDate(date);
        }
      }
    }
  });
  let tabIndex = null;
  if (!isDisabled) tabIndex = (0, $jzHdg$internationalizeddate.isSameDay)(date, state.focusedDate) ? 0 : -1;
  // Focus the button in the DOM when the state updates.
  (0, $jzHdg$react.useEffect)(() => {
    if (isFocused && ref.current) {
      (0, $jzHdg$reactariautils.focusWithoutScrolling)(ref.current);
      // Scroll into view if navigating with a keyboard, otherwise
      // try not to shift the view under the user's mouse/finger.
      // If in a overlay, scrollIntoViewport will only cause scrolling
      // up to the overlay scroll body to prevent overlay shifting.
      // Also only scroll into view if the cell actually got focused.
      // There are some cases where the cell might be disabled or inside,
      // an inert container and we don't want to scroll then.
      if ((0, $jzHdg$reactariainteractions.getInteractionModality)() !== "pointer" && document.activeElement === ref.current) (0, $jzHdg$reactariautils.scrollIntoViewport)(ref.current, {
        containingElement: (0, $jzHdg$reactariautils.getScrollParent)(ref.current)
      });
    }
  }, [isFocused, ref]);
  let cellDateFormatter = (0, $jzHdg$reactariai18n.useDateFormatter)({
    day: "numeric",
    timeZone: state.timeZone,
    calendar: date.calendar.identifier
  });
  let formattedDate = (0, $jzHdg$react.useMemo)(() => cellDateFormatter.formatToParts(nativeDate).find(part => part.type === "day").value, [cellDateFormatter, nativeDate]);
  return {
    cellProps: {
      role: "gridcell",
      "aria-disabled": !isSelectable || null,
      "aria-selected": isSelected || null,
      "aria-invalid": isInvalid || null
    },
    buttonProps: (0, $jzHdg$reactariautils.mergeProps)(pressProps, {
      onFocus() {
        if (!isDisabled) state.setFocusedDate(date);
      },
      tabIndex: tabIndex,
      role: "button",
      "aria-disabled": !isSelectable || null,
      "aria-label": label,
      "aria-invalid": isInvalid || null,
      "aria-describedby": [isInvalid ? errorMessageId : null, descriptionProps["aria-describedby"]].filter(Boolean).join(" ") || undefined,
      onPointerEnter(e) {
        // Highlight the date on hover or drag over a date when selecting a range.
        if ("highlightDate" in state && (e.pointerType !== "touch" || state.isDragging) && isSelectable) state.highlightDate(date);
      },
      onPointerDown(e) {
        // This is necessary on touch devices to allow dragging
        // outside the original pressed element.
        // (JSDOM does not support this)
        if ("releasePointerCapture" in e.target) e.target.releasePointerCapture(e.pointerId);
      },
      onContextMenu(e) {
        // Prevent context menu on long press.
        e.preventDefault();
      }
    }),
    isPressed: isPressed,
    isFocused: isFocused,
    isSelected: isSelected,
    isDisabled: isDisabled,
    isUnavailable: isUnavailable,
    isOutsideVisibleRange: date.compare(state.visibleRange.start) < 0 || date.compare(state.visibleRange.end) > 0,
    isInvalid: isInvalid,
    formattedDate: formattedDate
  };
}